<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    import type Connection from "../clienthandler";
    import DefaultContainer from "../DefaultContainer.svelte";

    import { state } from "../state";

    let resolve;
    let startGamePromise = new Promise((r) => (resolve = r));

    $state.connection.registerMessageListener("lobby", (message) => {
        switch (message.type) {
            case "LobbyJoined":
                $state.mySide = message.yourSide;
                $state.currentPage = "lobby";
                break;
            case "GameStarted":
                resolve();
                setTimeout(() => {
                    $state.currentPage = "game";
                }, 500);
                break;
        }

        // if (message.type === "GameStarted") {
        //     resolve();
        //     setTimeout(() => {
        //         $state.currentPage = "game";
        //     }, 500);
        // }
    });
    onDestroy(() => $state.connection.unregisterMessageListener("lobby"));
</script>

<DefaultContainer>
    <h1>Lobby #{$state.displayLobbyId}</h1>
    <p>Your side: {$state.mySide}</p>
    {#await startGamePromise}
        <p>Waiting for other player...</p>
    {:then _}
        <p>Game started!</p>
    {/await}
</DefaultContainer>
